import { useQuery } from '@tanstack/react-query';
import {
  fetchPostBySlug,
  fetchPosts,
  fetchProfile,
  fetchProjects,
  type PostListParams,
} from '../api/endpoints';

export function useProfile() {
  return useQuery({ queryKey: ['profile'], queryFn: fetchProfile });
}

export function usePosts(params: PostListParams) {
  return useQuery({
    queryKey: ['posts', params],
    queryFn: () => fetchPosts(params),
  });
}

export function usePost(slug: string | undefined) {
  return useQuery({
    queryKey: ['post', slug],
    queryFn: () => fetchPostBySlug(slug as string),
    enabled: Boolean(slug),
  });
}

export function useProjects(tag?: string) {
  return useQuery({
    queryKey: ['projects', tag ?? null],
    queryFn: () => fetchProjects(tag),
  });
}
